import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogBase, DialogOptions } from '@context/frontend/common';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton } from '@taiga-ui/core';

@Component({
	imports: [TranslocoModule, TuiButton],
	selector: 'ctx-logout-dialog',
	templateUrl: 'logout-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutDialogComponent extends DialogBase<boolean> {
	static override readonly DialogOptions = {
		label: 'navigation.sign-out',
		size: 's',
	} as DialogOptions;
}
